<template>
    <ion-item lines="none" class="grey-background">
        <div class="w-100 option-wrapper text">
            <h6 class="label">{{ label }}</h6>
            <p v-if="option && option.type !== 'describe-yourself' && option.type !== 'describe-others'" class="value">
                {{ option ? $t('options.' + option.value) : '----' }}
            </p>
            <p v-else class="value">
                {{ option ? option.pivot.details : '----' }}
            </p>
        </div>
    </ion-item>
</template>

<script>
export default {
    name: 'UserOption',
    props: ['option', 'label']
}
</script>

<style lang="scss" scoped>
.option-wrapper.text {
    .label {
        margin-bottom: 5px;
    }
    .value {
        margin-top: 0;
        line-height: 140%;
        font-weight: 700;
    }
}

.w-100 {
    width: 100%;
}

@media (min-width: 768px) {
    .text {
        .label,
        .value {
            font-size: 20px;
        }
    }
}

@media (min-width: 1200px) {
    .text {
        .label,
        .value {
            font-size: 16px !important;
        }
    }

    .option-wrapper.text {
        .label {
            margin-top: 0 !important;
        }
    }
}
</style>
